const styles = (theme => ({
  helpIcon: {
    verticalAlign: 'bottom',
    fontSize: '1.1rem'
  }
}));

export default styles;